import { createAction } from '@reduxjs/toolkit';
import User from 'types/entities/User';
import { initialValue } from '../../helperContext';
import { BaselineAffectationType, PossiblesBaselineAffectationActions } from '../../BaselineAffectationReducers';

export const setAffectationClientsAction = createAction(
  BaselineAffectationType.SetAffectationClients,
  (clients: User[]) => ({
    payload: { clients },
  })
);

export default (state = initialValue, action: PossiblesBaselineAffectationActions) => {
  switch (action.type) {
    case BaselineAffectationType.SetAffectationClients:
      return {
        ...state,
        clients: action.payload.clients,
      };
    default:
      return state;
  }
};
